
import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableSortLabel,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    TextField,
    Button,
    FormControl,
    InputLabel,
    Select,
    Paper,
    Chip
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses';
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import AddIcon from "@mui/icons-material/Add";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {useTheme} from '@mui/material/styles';
import {ListViewModel,
        ListViewColumnModel,
        EmailContextObjectModel,
        EmailRecipientModel,
        EmailTemplateModel,
        RecordModel} from '../../models/models';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {SearchFieldComponent} from "../../components/searchField/SearchField";
import {useSnackbar} from "notistack";
import { formatDate, formatDatetime } from "../../utils/dateFunctions";
import {Link, useParams} from 'react-router-dom';
import {getAppName, getObjectName } from "../../utils/helperRouter";
import {validateEmailField} from '../../utils/fieldValidations';
import {LookupDialogComponent} from "../fields/LookupDialog";

export const EmailContextObjectComponent: React.FC<{
  contextObject: EmailContextObjectModel,
  onChange: (selectedRecord: RecordModel) => void
}> = ({
  contextObject,
  onChange
}) => {


  const thisValue = contextObject.referencedRecord.lookupDisplayValue;

  const error = () => {
    if(!contextObject.referencedRecord.Uuid_sys) return true;
    return false
  };


  const [openLookupDialog, setOpenLookupDialog] = useState<boolean>(false);

  const handleSearch = () => {
    setOpenLookupDialog(!openLookupDialog);
  }

  const handleChange = (selectedRecord: RecordModel | null) => {
    if(selectedRecord){
      onChange(selectedRecord)
    }
    setOpenLookupDialog(!openLookupDialog);
  }


  return (

    <>
    <LookupDialogComponent
      objectApiName={contextObject.ReferencedObject_c.ApiName_sys}
      openDialog={openLookupDialog}
      onCloseDialog={() => {
        setOpenLookupDialog(false);
          }}
      onSelect={handleChange}
    />

   <Box>
     <TextField
        fullWidth
        disabled
        error={error()}
        required={true}
        size="small"
        label={`${contextObject.ContextKey_c} (${contextObject.ReferencedObject_c.Label_sys} context)`}
        variant="filled"
        value={thisValue ?? ''}
        inputProps={{
          maxLength: 255,
          onClick: () => console.log("field clicked")
        }}
        InputProps={{
          disableUnderline: true,
          endAdornment: (
            <InputAdornment position="end">
               <IconButton size="small" onClick={() => handleSearch()}>
               <SearchIcon />
              </IconButton>
          </InputAdornment>
        )
       }}
    />

    </Box>
    </>
    )
};
